{
  "nl": {
    "todo_group": {
      "actions": {
        "create": "Taak",
        "update": "Taak bewerken"
      },
      "attributes": {
        "category": "Categorie",
        "created_at": "Aangemaakt",
        "description": "Omschrijving",
        "title": "Titel",
        "todos_count": "Taken",
        "units": "Eenheden"
      },
      "categories": {
        "confirmation": "Bevestiging",
        "upload": "Upload"
      },
      "labels": {
        "no_groups": "Nog geen taken voor dit project.",
        "required": "Dit veld is verplicht"
      },
      "toasts": {
        "create": "Taak aangemaakt",
        "delete": "Taak verwijderd",
        "update": "Taak bijgewerkt"
      }
    }
  }
}
